import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminAuthProvider, useAdminAuth } from './contexts/AdminAuthContext';
import AdminLayout from './components/AdminLayout';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminMechsPage from './pages/AdminMechsPage';
import AdminPilotsPage from './pages/AdminPilotsPage';
import AdminModsPage from './pages/AdminModsPage';
import AdminSkinsPage from './pages/AdminSkinsPage';
import AdminUpgradeCostsPage from './pages/AdminUpgradeCostsPage';
import AdminPlayersPage from './pages/AdminPlayersPage';

const AdminRoutes = () => {
  const { isAuthenticated, isLoading } = useAdminAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-[#121212]">
        <div className="text-gray-500 dark:text-gray-400">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <AdminLoginPage />;
  }

  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboardPage />} />
        <Route path="mechs" element={<AdminMechsPage />} />
        <Route path="pilots" element={<AdminPilotsPage />} />
        <Route path="mods" element={<AdminModsPage />} />
        <Route path="skins" element={<AdminSkinsPage />} />
        <Route path="upgrade-costs" element={<AdminUpgradeCostsPage />} />
        <Route path="players" element={<AdminPlayersPage />} />
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Route>
    </Routes>
  );
};

const AdminApp = () => (
  <AdminAuthProvider>
    <AdminRoutes />
  </AdminAuthProvider>
);

export default AdminApp;
